/**
 * Mounts an attribute on a node.
 */
function safelyMountNodeAttr(node, attr, value) {
  if (node instanceof HTMLElement) {
    var current = node.getAttribute(attr);
    if (value !== undefined && value !== current) {
      node.setAttribute(attr, value);
    }
  }
}

/**
 * Toggles aria attributes on all slides.
 */
function toggleAriaSlideAttrs(emblaApi) {
  if (!emblaApi) {
    return;
  }
  var slides = emblaApi.slideNodes();
  var visibleSlides = emblaApi.slidesInView();
  slides.forEach(function (slide, index) {
    if (!slide) return;
    var visible = visibleSlides.includes(index);

    // Handle inert attribute - add when not visible, remove when visible
    if (slide instanceof HTMLElement) {
      if (visible) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    }
    safelyMountNodeAttr(slide, 'aria-selected', visible ? 'true' : 'false');
  });
}

/**
 * Finds the page index that contains the specified card index.
 *
 * @param groupedSlides - Array of slide groups where each group represents a page
 * @param currentCard - The card index to find (0-based)
 * @returns The page index that contains the card
 */
function findPageIndexByCardIndex(groupedSlides, currentCard) {
  // If currentCard is negative, return the first page
  if (currentCard < 0) {
    return 0;
  }

  // Find the page index that contains the target card by checking cumulative slides
  var targetPageIndex = groupedSlides.findIndex(function (_, i) {
    var totalSlides = groupedSlides.slice(0, i + 1).flat().length;
    return totalSlides > currentCard;
  });
  return targetPageIndex;
}

export { findPageIndexByCardIndex, safelyMountNodeAttr, toggleAriaSlideAttrs };
//# sourceMappingURL=helpers.js.map
